import { render, staticRenderFns } from "./customDistribuTion.vue?vue&type=template&id=27d5de78&scoped=true&"
import script from "./customDistribuTion.vue?vue&type=script&lang=js&"
export * from "./customDistribuTion.vue?vue&type=script&lang=js&"
import style0 from "./customDistribuTion.vue?vue&type=style&index=0&id=27d5de78&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d5de78",
  null
  
)

export default component.exports